/**
 * Collection Drop Modal Functionality
 * Handles opening/closing modal popups for Klaviyo forms
 */

(function() {
  'use strict';

  // Open modal
  function openModal(modalId) {
    const modal = document.querySelector(`[data-modal="${modalId}"]`);
    if (!modal) return;
    
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    
    // Focus trap
    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }
  }

  // Close modal
  function closeModal(modalId) {
    const modal = document.querySelector(`[data-modal="${modalId}"]`);
    if (!modal) return;
    
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  }

  // Initialize modal triggers
  function initModals() {
    // Open modal on button click
    document.querySelectorAll('[data-modal-trigger]').forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const modalId = this.getAttribute('data-modal-trigger');
        openModal(modalId);
      });
    });

    // Close modal on close button click
    document.querySelectorAll('[data-modal-close]').forEach(closeBtn => {
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const modalId = this.getAttribute('data-modal-close');
        closeModal(modalId);
      });
    });

    // Close modal on overlay click
    document.querySelectorAll('.cd-modal-overlay').forEach(overlay => {
      overlay.addEventListener('click', function(e) {
        if (e.target === this) {
          const modalId = this.getAttribute('data-modal');
          closeModal(modalId);
        }
      });
    });

    // Close modal on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        document.querySelectorAll('.cd-modal-overlay[aria-hidden="false"]').forEach(modal => {
          const modalId = modal.getAttribute('data-modal');
          closeModal(modalId);
        });
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModals);
  } else {
    initModals();
  }

  // Re-initialize on Shopify section load (theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initModals);
  }
})();
